import React,{useContext} from "react"
import { Grid, Typography, Divider, MenuItem} from "@material-ui/core"
import { ControlledTextField} from "../../Core/Form/ControlledFields";
import { useFormContext } from "react-hook-form";
import { QuoteContextStore } from '../../../context/QuoteContext/QuoteContext';

const AirportManualSearch = ({...props}) => {
    const { watch, register } = useFormContext();
    const notFound = watch("airport_not_found");
    const {locked_quote} = useContext(QuoteContextStore)

    return (
    notFound ? 
        (<React.Fragment>
            <Grid item xs={12}><Divider className="margin-0"/></Grid>
            <Grid item xs={12}><Typography variant="h3" className="blue">Please provide additional airport details</Typography></Grid>
            <Grid item xs={12} md={4}>
                <Typography variant="h4" className="gray">Airport city</Typography>
                <ControlledTextField autoComplete='ViewCrunch' fullWidth name="city" className="margin-top-8" placeholder="City" disabled={locked_quote}/>
            </Grid>
            <Grid item xs={12} md={4}>
                <Typography variant="h4" className="gray">Airport name</Typography>
                <ControlledTextField autoComplete='ViewCrunch' fullWidth name="name" className="margin-top-8" placeholder="Name" disabled={locked_quote}/>
            </Grid>
            <Grid item xs={12} md={4}>
                <Typography variant="h4" className="gray">Runway length</Typography>
                <ControlledTextField fullWidth name="runway_length" className="margin-top-8" placeholder="Length" type="number" disabled={locked_quote}/>
            </Grid>
            <Grid item xs={12} md={4}>
                <Typography variant="h4" className="gray">Runway surface</Typography>
                <ControlledTextField fullWidth name="runway_surface" className="margin-top-8" select placeholder="Surface type" disabled={locked_quote}>
                    <MenuItem selected disabled value="default"><span className="placeholder-gray">Surface type</span></MenuItem>
                    <MenuItem value="CONC">Concrete</MenuItem>
                    <MenuItem value="TURF">Turf/Grass</MenuItem>
                    <MenuItem value="ASPH">Asphalt</MenuItem>
                    <MenuItem value="GRVL">Gravel</MenuItem>
                    <MenuItem value="DIRT">Dirt</MenuItem>
                </ControlledTextField>
            </Grid>
            <Grid item xs={12} md={4}>
                <Typography variant="h4" className="gray">Field elevation (feet)</Typography>
                <ControlledTextField fullWidth name="runway_elevation" className="margin-top-8" placeholder="Feet" type="number" disabled={locked_quote}/>
            </Grid>
        </React.Fragment>) : (<>
            <input hidden {...register("runway_length")} />
            <input hidden {...register("runway_surface")}/>
            <input hidden {...register("runway_elevation")}/>
            <input hidden {...register("code")}/>
        </>
        )
    )
}

export default AirportManualSearch;